import { type FC, useState } from 'react'

import { type ChatMessageStatus } from '@api'

import { Button } from '@/components/ui/button'

import { OverviewHeader } from '../overview-header/OverviewHeader'
import { OverviewTable } from '../overview-table/OverviewTable'

interface Props {
  onClose: () => void
  isOpen: boolean
}

export const OverviewWrapper: FC<Props> = ({ onClose, isOpen }) => {
  const [status, setStatus] = useState<ChatMessageStatus>()

  return (
    <>
      <OverviewHeader onChange={setStatus} />
      <OverviewTable
        status={status}
        isOpen={isOpen}
        onClose={onClose}
      />
      <div className="flex justify-end">
        <Button
          onClick={onClose}
          variant="outline"
        >
          Close
        </Button>
      </div>
    </>
  )
}
